// Called with a single container by the lazy-init observer below; called with no
// argument (all containers) by the theme editor and any external caller.
window.initRecentlyViewed = function (targetContainer) {
  const containers = targetContainer ? [targetContainer] : document.querySelectorAll('.recently-viewed-container');
  if (!containers.length) return;
  // Retrieve valid product IDs
  const ids = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
  const currentId = (document.querySelector('[data-product-id]') || {}).dataset?.productId;
  const filteredIds = currentId ? ids.filter(id => String(id) !== String(currentId)) : ids;
  const maxItems = 10;
  const limitedIds = filteredIds.slice(0, maxItems);
  // If no recently viewed products found, section remains hidden
  if (!limitedIds.length) {
    containers.forEach(container => {
      const groupBlock = container.closest('.group-block') || container.closest('.recently-viewed') || container.closest('.block-recently-viewed');
      if (groupBlock) {
        groupBlock.style.display = 'none';
      }
    });
    return;
  }
  const query = limitedIds.map(id => `id:${id}`).join(' OR ');
  containers.forEach(container => {
    if (container.dataset.isFetching === 'false' && container.style.display === 'none') {
      const sectionId = container.dataset.sectionId;
      if (!sectionId) return;
      const searchUrl = `${window.Shopify.routes.root}search?type=product&q=${encodeURIComponent(query)}&section_id=${sectionId}`;
      fetch(searchUrl)
        .then(res => res.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const newSection = doc.getElementById(`recently-viewed-${sectionId}`);
          if (newSection && newSection.innerHTML.trim() !== '') {
            container.innerHTML = newSection.innerHTML;
            container.style.display = '';
            // Initialization queue
            setTimeout(() => {
              if (typeof initRVSwiperForContainer === 'function') {
                initRVSwiperForContainer(container);
              }
            }, 50);
            // Inserted slideshow-component elements bind their own scrollbar on connect
            // (assets/slideshow.js).
          } else {
            const groupBlock = container.closest('.group-block') || container.closest('.recently-viewed') || container.closest('.block-recently-viewed');
            if (groupBlock) {
              groupBlock.style.display = 'none';
            }
          }
        })
        .catch(e => {
          if (e && (e.name === 'AbortError' || e === 'canceled' || e.message === 'canceled')) return;
          console.warn('Recently Viewed Error:', e);
        });
    } else {
      // If loaded directly in theme editor, init immediately
      initRVSwiperForContainer(container);
    }
  });
};

// This file is loaded twice on some templates (blocks/recently-viewed.liquid and
// sections/recently-viewed.liquid each add their own <script src>), so latch the boot.
if (!window.recentlyViewedBooted) {
  window.recentlyViewedBooted = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupRecentlyViewedLazyInit);
  } else {
    setupRecentlyViewedLazyInit();
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      const container = event.target.querySelector('.recently-viewed-container');
      if (container) initRVSwiperForContainer(container);
    });
  }
}

// Load data and Swiper when the section approaches the viewport.
function setupRecentlyViewedLazyInit() {
  const containers = document.querySelectorAll('.recently-viewed-container');
  if (!containers.length) return;

  if (!('IntersectionObserver' in window)) {
    window.initRecentlyViewed();
    return;
  }

  containers.forEach(function (container) {
    if (container.dataset.lazyInitObserved) return;
    container.dataset.lazyInitObserved = 'true';

    // The container itself renders as display:none until it has content, and a
    // display:none element never intersects — observe the wrapper that keeps its layout.
    // In sections/recently-viewed.liquid the container IS the section's top element, so
    // the only layout-bearing ancestor is the shopify-section wrapper itself.
    const target = container.closest('.group-block')
      || container.closest('.recently-viewed')
      || container.closest('.block-recently-viewed')
      || container.closest('.shopify-section')
      || container;

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.disconnect();
        window.initRecentlyViewed(container);
      });
    }, { rootMargin: '200px 0px' });
    observer.observe(target);
  });
}

function initRVSwiperForContainer(rootContainer) {
  const container = rootContainer.querySelector('.rv-swiper');
  if (!container) return;
  const slides = container.querySelectorAll('.swiper-slide');
  if (slides.length === 0) return;
  // Swiper is fetched on demand (assets/swiper-loader.js). Only ask for it once this
  // container really has slides to show, then run again with the library in place.
  if (!window.Swiper) {
    if (typeof window.loadSwiper === 'function') {
      window.loadSwiper().then(() => initRVSwiperForContainer(rootContainer)).catch(() => {});
    }
    return;
  }
  const gap = parseFloat(getComputedStyle(container).getPropertyValue('--rv-gap')) || 8;
  const hasEnoughForLoop = slides.length >= 6;
  const sliderMode = container.getAttribute('data-slider-mode') || 'option2';
  const isOption1 = sliderMode === 'option1';
  let offsetPadding = 0;
  function updateOption1Layout() {
    if (isOption1 && window.innerWidth >= 750) {
      const headerTitle = rootContainer.querySelector('.section-resource-list__header');
      if (headerTitle) {
        const computed = window.getComputedStyle(headerTitle);
        const paddingLeft = parseFloat(computed.paddingLeft) || 0;
        offsetPadding = headerTitle.getBoundingClientRect().left + paddingLeft;
        container.style.setProperty('--option1-offset', offsetPadding + 'px');
      }
    }
  }
  updateOption1Layout();
  // Handle window resize offsets for Option 1
  let swiperInstance = null;
  function handleResize() {
    if (isOption1 && window.innerWidth >= 750 && swiperInstance) {
      updateOption1Layout();
      swiperInstance.params.slidesOffsetBefore = offsetPadding;
      swiperInstance.params.slidesOffsetAfter = offsetPadding;
      swiperInstance.update();
    }
  }
  // Keep one resize listener for each container.
  if (rootContainer.rvResizeHandler) {
    window.removeEventListener('resize', rootContainer.rvResizeHandler);
  }
  rootContainer.rvResizeHandler = handleResize;
  window.addEventListener('resize', handleResize);
  swiperInstance = new Swiper(container, {
    spaceBetween: gap,
    allowTouchMove: false,
    observer: false,
    observeParents: false,
    resizeObserver: false,
    navigation: {
      nextEl: rootContainer.querySelector('.rv-slider-next'),
      prevEl: rootContainer.querySelector('.rv-slider-prev'),
    },
    pagination: {
      el: rootContainer.querySelector('.swiper-pagination'),
      type: 'progressbar',
    },
    watchSlidesProgress: true,
    preventInteractionOnTransition: true,
    breakpoints: {
      0: {
        allowTouchMove: true,
        slidesPerView: 'auto',
        centeredSlides: false,
        loop: false,
        slidesOffsetBefore: 16,
        slidesOffsetAfter: 16
      },
      750: {
        allowTouchMove: false,
        slidesPerView: 'auto',
        loop: isOption1 ? false : hasEnoughForLoop,
        slidesOffsetAfter: 16,
        slidesOffsetBefore: 16
      }
    },
    on: {
      init: function () {
        const isMobile = window.innerWidth <= 749;
        const arrows = rootContainer.querySelector('slideshow-arrows');
        const progressbar = rootContainer.querySelector('.swiper-pagination');
        if (isMobile) {
          if (arrows) arrows.style.display = 'none';
          if (progressbar) progressbar.style.display = 'block';
        } else {
          if (arrows) arrows.style.display = 'block';
          if (progressbar) progressbar.style.display = 'none';
        }
        requestAnimationFrame(setArrowPosition);
      },
      resize: function () {
        const isMobile = window.innerWidth <= 749;
        const arrows = rootContainer.querySelector('slideshow-arrows');
        const progressbar = rootContainer.querySelector('.swiper-pagination');
        if (isMobile) {
          if (arrows) arrows.style.display = 'none';
          if (progressbar) progressbar.style.display = 'block';
        } else {
          if (arrows) arrows.style.display = 'block';
          if (progressbar) progressbar.style.display = 'none';
        }
        requestAnimationFrame(setArrowPosition);
      }
    }
  });
  function setArrowPosition() {
    const firstImg = container.querySelector('.image-block__image, .product-media__image');
    if (firstImg) {
      const imgH = firstImg.offsetHeight;
      if (imgH > 0) {
        container.style.setProperty('--arrow-top', (imgH / 2) + 'px');
      }
    }
  }
}
